import { render, staticRenderFns } from "./p_esg026.vue?vue&type=template&id=70f69dec&scoped=true&"
import script from "./p_esg026.vue?vue&type=script&lang=js&"
export * from "./p_esg026.vue?vue&type=script&lang=js&"
import style0 from "./p_esg026.vue?vue&type=style&index=0&id=70f69dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f69dec",
  null
  
)

export default component.exports